import axiosInstance from "./axiosInstance";

const unwrapError = (error, fallback) =>
  error.response?.data?.message ||
  error.response?.data?.error ||
  fallback;

export const fetchFinkedaGateways = async () => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/gateways`);
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Failed to load gateways") };
  }
};


export const deleteMatmCustomer = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/finkeda/customers/${id}`);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Customer deleted",
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Delete failed") };
  }
};

export const createFinkedaCheckout = async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/finkeda/checkout`, payload);
    const data = response?.data?.data || response?.data || {};
    return {
      success: true,
      data,
      message: response?.data?.message || "Checkout created",
      redirectionUrl: data.redirectionUrl || data.redirectUrl || null,
      kycUrl: data.kycUrl || null,
      requiresKyc: Boolean(data.requiresKyc),
      urn: data.urn,
      walletWarning: data.walletWarning || null,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Checkout failed") };
  }
};

export const checkFinkedaStatus = async (orderId) => {
  try {
    const response = await axiosInstance.post(`/api/finkeda/status`, { orderId });
    return {
      success: true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Status check failed") };
  }
};

export const fetchMyFinkedaOrders = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/orders`, { params });
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Failed to load orders") };
  }
};

export const fetchMyFinkedaAnalytics = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/analytics`, { params });
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return {
      success: false,
      message: unwrapError(error, "Failed to load performance analytics"),
    };
  }
};

export const fetchFinkedaPayoutPricing = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/payout-pricing`, {
      params,
    });
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return {
      success: false,
      message: unwrapError(error, "Failed to load payout pricing"),
    };
  }
};

export const searchMatmCustomers = async (params = {}) => {
  try {
    const payload = typeof params === "string" ? { query: params } : params || {};
    const response = await axiosInstance.get(`/api/finkeda/customers`, {
      params: {
        q: payload.query ?? payload.q ?? "",
        filterType: payload.filterType || payload.filter || "all",
        page: payload.page || 1,
        limit: payload.limit || 10,
      },
    });
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Search failed"), data: { items: [] } };
  }
};

export const getMatmCustomer = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/customers/${id}`);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Customer not found") };
  }
};

export const saveMatmCustomerForBankVerification = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `/api/finkeda/customers/verification-source`,
      payload
    );
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Customer saved",
    };
  } catch (error) {
    return {
      success: false,
      message: unwrapError(error, "Failed to save customer"),
    };
  }
};
